// Группы «Клиентского портфеля» (ключи ответа GET /api/companies/clients_portfolio)
export const PORTFOLIO_GROUPS = {
  active: {
    label: "Активные",
    color: "#38c12b",
    description: "Была хотя бы одна поставка за последний месяц (новые и действующие)",
  },
  potential: {
    label: "Потенциальные",
    color: "#9e9e9e",
    description: "Поступил запрос, договор может быть подписан или не подписан. Поставок не было",
  },
  new: {
    label: "Новые",
    color: "#36acf4",
    description: "Стартовала хотя бы одна поставка, с даты погрузки первой поставки прошло менее 6 месяцев",
  },
  current: {
    label: "Действующие",
    color: "#2dbd63",
    description: "Работаем более 6 месяцев с даты первой погрузки, и есть отгрузки за последние 3 месяца",
  },
  leaving: {
    label: "Уходящие",
    color: "#ff9800",
    description: "Нет поставок более 3 месяцев, но менее 6",
  },
  lost: {
    label: "Утерянные",
    color: "#f44336",
    description: "Нет фактически выполненных поставок в течение 6 месяцев",
  },
  returned: {
    label: "Возвращенные",
    color: "#8bc34a",
    description: "Ранее утерянный или уходящий клиент возобновил поставки. После 3 поставок считается «Действующим»",
  },
  archive: {
    label: "Архивные",
    color: "#607d8b",
    description: "Клиенты со статусом «Black list» или «Ликвидирован»",
  },
  at_risk: {
    label: "В зоне риска",
    color: "#e91e63",
    description: "Есть финансовые или другие риски работы с клиентом (признак ставится вручную)",
  },
  not_calculated: {
    label: "Не рассчитаны",
    color: "#bcbab9",
    description: "Статус ещё не пересчитан по новым правилам",
  },
};

export function groupLabel(key) {
  return PORTFOLIO_GROUPS[key] ? PORTFOLIO_GROUPS[key].label : key;
}

export function groupColor(key) {
  return PORTFOLIO_GROUPS[key] ? PORTFOLIO_GROUPS[key].color : "#bcbab9";
}
